import { ArtworkProps } from './types';

export const normalizePoints = (points: number[][], bbox: ReturnType<typeof bboxUtil>) =>
    points.map((point) => [point[0] - bbox.left, point[1] - bbox.top]);

export function isCustomArtworkImage(leftArtwork: ArtworkProps) {
    return leftArtwork?.leftImage && leftArtwork?.displayName.includes('Custom Artwork');
}

export const isArtworkEditableByName = (artwork: ArtworkProps) => {
    return Boolean(artwork?.leftImage && artwork?.displayName.includes('Custom Artwork'));
};

export const isDraggableBySide = (currentSide: string, artworkSide: string) => {
    return Boolean(currentSide === artworkSide || currentSide === 'both');
};

export const isDraggable = (artwork: ArtworkProps, currentSide: string, artworkSide: string) => {
    return isArtworkEditableByName(artwork) && isDraggableBySide(currentSide, artworkSide);
};
export const bboxUtil = (points: number[][]) =>
    points.reduce(
        (sum, item) => {
            const x = item[0];
            const y = item[1];
            sum.top = y < sum.top ? y : sum.top;
            sum.bottom = y > sum.bottom ? y : sum.bottom;
            sum.left = x < sum.left ? x : sum.left;
            sum.right = x > sum.right ? x : sum.right;
            sum.width = sum.right - sum.left;
            sum.height = sum.bottom - sum.top;
            sum.centerX = (sum.left + sum.right) / 2;
            sum.centerY = (sum.top + sum.bottom) / 2;
            return sum;
        },
        {
            top: Infinity,
            left: Infinity,
            right: -Infinity,
            bottom: -Infinity,
            centerX: 0,
            centerY: 0,
            width: 0,
            height: 0
        }
    );
